import { AdminClient } from '@bounded/api-client';

/** `vite --mode mock` swaps the network for in-memory fixtures; nothing mock-related ships in real builds. */
export const isMock = import.meta.env.MODE === 'mock';
const transport = isMock ? (await import('./mock/transport')).mockTransport : undefined;
export const api = new AdminClient(window.location.origin, transport);
